import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import { Button } from "reactstrap";
import DataTable from "../../../Shared/DataTable";
import { MdAdd } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { UserUploadContents } from "../../../../_constants/RouteVariables";
import { MdModeEdit, MdDelete } from "react-icons/md";

import { dateTimeutils, dateFormats } from "../../../../_utils";

import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { tourMessages } from "../../../../_constants/tutorialmessages/ManualMessages";

export class DraftContentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "all",
      run: false,
      stepIndex: 0,
      steps: [
        {
          target: tourMessages.instructorDraftTable.target,
          content: (
            <div>
              <p>{tourMessages.instructorDraftTable.title}</p>
              <p
                style={{ color: "blue", fontStyle: "italic", fontSize: "15px" }}
              >
                {tourMessages.instructorDraftTable.content}
              </p>
            </div>
          ),
          placement: "left",
          locale: { skip: "SKIP" , close: 'Next'},
        },
        tourMessages.default,
      ],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showNextJoyRide) {
      this.setState({ run: true });
      this.props.setNextJoyRide();
    }
  }
  handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    } else if ([STATUS.CANCEL, STATUS.CANCEL].includes(status)) {
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if ([STATUS.SKIPPED].includes(status)) {
        this.setState({ run: false });
      } else {
        this.props.routeChange();
      }
    }
  };
  render() {
    const columns = [
      {
        Header: "Interest",
        accessor: "interestName",
      },
      {
        Header: "Title",
        accessor: "title",
      },
      {
        Header: "Created On",
        id: "draftedOn",
        accessor: row => {
          return dateTimeutils.formatDateTime(
            row.draftedOn,
            dateFormats.localFormatLong
          );
        },
      },
      {
        Header: "Last Updated On",
        id: "lastDraftUpdateOn",
        accessor: row => {
          return dateTimeutils.formatDateTime(
            row.lastDraftUpdateOn,
            dateFormats.localFormatLong
          );
        },
      },
    ];

    const {
      match,
      fetching,
      data,
      error,
      selectRow,
      deleteInterest,
      showModal,
      pages,
      page,
      pageSize,
      setPageNumber,
      filterData,
      setPageSize,
    } = this.props;
    const { run, steps, stepIndex } = this.state;
    const actions = [
      {
        name: "edit",
        btnText: "Edit",
        isLink: true,
        to: UserUploadContents,
        btnAction: selectRow,
        btnClass: "btn-primary",
        btnIcon: MdModeEdit,
        tooltip: "Edit"
      },
      {
        name: "delete",
        btnText: "Delete",
        btnAction: showModal,
        btnClass: "btn-danger",
        btnIcon: MdDelete,
        tooltip: "Delete"
      },
    ];

    return (
      <div>
        <Joyride
          steps={steps}
          scrollToFirstStep
          showProgress
          showSkipButton
          styles={{
            options: {
              width: 200,
              height: 60,
              zIndex: 1000,
            },
          }}
          callback={this.handleJoyrideCallback}
          run={run}
          stepIndex={stepIndex}
        />
        <Card>
          <CardHeader>Drafts</CardHeader>
          <CardBody className="joyride11">
            {error && (
              <UncontrolledAlert color="danger">
                {error.message}
              </UncontrolledAlert>
            )}

            <NavLink to={UserUploadContents}>
              <Button color="primary mb-2" size="sm">
                <MdAdd /> Add
              </Button>
            </NavLink>

            <DataTable
              columns={columns}
              loading={fetching}
              urlParams={match}
              data={data ? data.content : []}
              count={data ? data.count : 0}
              defaultPageSize={5}
              deleteRow={deleteInterest}
              selectRow={selectRow}
              showModal={showModal}
              manual={true}
              pages={pages}
              page={page}
              pageSize={pageSize}
              showInstructorActions={false}
              isUser={true}
              filterData={filterData}
              setPageNumber={setPageNumber}
              setPageSize={setPageSize}
              searchParam="searchKey"
              searchPlaceholder="Search by title"
              actions={actions}
            />
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default DraftContentTable;
